import { render, staticRenderFns } from "./hospitalHome.vue?vue&type=template&id=104df66f&scoped=true&"
import script from "./hospitalHome.vue?vue&type=script&lang=js&"
export * from "./hospitalHome.vue?vue&type=script&lang=js&"
import style0 from "./hospitalHome.vue?vue&type=style&index=0&id=104df66f&lang=less&scoped=true&"
import style1 from "./hospitalHome.vue?vue&type=style&index=1&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "104df66f",
  null
  
)

export default component.exports